/**
 * ForbiddenPage — B2C Merchant Portal
 *
 * Shown when an authenticated user navigates to a screen they lack
 * permissions for. Provides clear feedback and recovery actions.
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function ForbiddenPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname;

  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ maxWidth: '28rem', width: '100%', textAlign: 'center' }}>
        <div
          style={{
            margin: '0 auto 1.5rem',
            display: 'flex',
            height: '5rem',
            width: '5rem',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            backgroundColor: '#FEF2F2',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#EF4444"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            <line x1="4.5" y1="4.5" x2="19.5" y2="19.5" />
          </svg>
        </div>

        <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#111827' }}>
          Access Denied
        </h1>

        <p style={{ marginTop: '0.75rem', fontSize: '0.875rem', color: '#6B7280' }}>
          You don&apos;t have permission to access this page.
          {from && (
            <span style={{ display: 'block', marginTop: '0.25rem', fontFamily: 'monospace', fontSize: '0.75rem', color: '#9CA3AF' }}>
              Requested: {from}
            </span>
          )}
        </p>

        <p style={{ marginTop: '0.5rem', fontSize: '0.75rem', color: '#9CA3AF' }}>
          If you believe this is an error, contact your administrator
          to request the required permissions.
        </p>

        <div style={{ marginTop: '2rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.75rem' }}>
          <button
            type="button"
            onClick={() => navigate('/all-shipments', { replace: true })}
            style={{
              borderRadius: '0.5rem',
              backgroundColor: '#2563EB',
              padding: '0.625rem 1.25rem',
              fontSize: '0.875rem',
              fontWeight: 500,
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Go to Dashboard
          </button>
          <button
            type="button"
            onClick={() => navigate(-1)}
            style={{
              borderRadius: '0.5rem',
              border: '1px solid #D1D5DB',
              padding: '0.625rem 1.25rem',
              fontSize: '0.875rem',
              fontWeight: 500,
              color: '#374151',
              backgroundColor: '#fff',
              cursor: 'pointer',
            }}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
